import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { BreadcrumbsService } from '../../core/breadcrumbs.service';
import { FormGroup, FormControl } from '@angular/forms';
import { ScrollService } from '../../core/scroll.service';
import { IAccountType } from '../../constants/account-types';
import { LoginGuardService } from '../../api/login-guard.service';
import { LangService } from '../../core/lang.service';

@Component({
  selector: 'forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.scss']
})
export class ForgotPasswordComponent implements OnInit {

  public breadcrumb = [];
  public isFormValidated:boolean;

  public formGroup = new FormGroup({
    emailAddress: new FormControl(),
  })

  constructor(
    private loginGuard: LoginGuardService, // 
    private lang: LangService,
    private breadcrumbsService: BreadcrumbsService,
    private router:Router,
    private scrollService: ScrollService,
  ) { }
  
  ngOnInit() {
    this.loginGuard.deactivate();
    this.scrollService.scrollToTop();
    this.breadcrumb = [
      this.breadcrumbsService.HOME(),
      this.breadcrumbsService._CURRENT( this.lang.tra('title_forgot_password'), this.router.url),
    ];
  }

  submitForm(){
    this.scrollService.scrollToTop();
    this.isFormValidated = true;
    this.formGroup.controls.emailAddress.disable()
  }

}
